<template>
  <div class="tinymce-container editor-container" :class="{fullscreen:fullscreen}">
    <textarea class="tinymce-textarea" :id="tinymceId"></textarea>
    <div class="editor-custom-btn-container">
      <!-- <chatSendFile color="#1890ff" class="editor-upload-btn" @successCBK="fileSuccess"></chatSendFile> -->
      <chatSendImage class="editor-upload-btn" @successCBK="imageSuccessCBK"></chatSendImage>
    </div>
  </div>
</template>

<script>
  import plugins from './plugins1';
  import toolbar from './toolbar';
  import chatSendImage from './components/chatSendImage';
  // import chatSendFile from './components/chatSendFile';

  export default {
    name: 'tinymce',
    components: {
      chatSendImage
    },
    props: {
      id: {
        type: String
      },
      value: {
        type: String,
        default: ''
      },
      toolbar: {
        type: Array,
        required: false,
        default () {
          return [];
        }
      },
      height: {
        type: Number,
        required: false,
        default: 360
      },
      meDataId: {
        type: Number,
        required: false,
        default: 0
      },
      toUserRole: {
        type: Number,
        required: false,
        default: 0
      }
    },
    data() {
      return {
        hasChange: false,
        hasInit: false,
        tinymceId: this.id || 'vue-tinymce-' + +new Date(),
        fullscreen: false,
      };
    },
    watch: {
      value(val) {
        if (!this.hasChange && this.hasInit) {
          this.$nextTick(() =>
            window.tinymce.get(this.tinymceId).setContent(val || ''));
        }
      },
    },
    mounted() {
      this.initTinymce();
    },
    activated() {
      this.initTinymce();
    },
    deactivated() {
      this.destroyTinymce();
    },
    methods: {
      initTinymce() {
        const _this = this;
        window.tinymce.init({
          language: 'zh_CN',
          selector: `#${this.tinymceId}`,
          height: this.height,
          body_class: 'tinyBack',
          object_resizing: false,
          toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
          menubar: false,
          statusbar: false,
          forced_root_block: '',
          force_br_newlines: false,
          force_p_newlines: false,
          auto_focus: true,
          contextmenu_never_use_native: true,
          plugins: plugins,
          end_container_on_empty_block: true,
          powerpaste_word_import: 'clean',
          code_dialog_height: 450,
          code_dialog_width: 1000,
          advlist_bullet_styles: 'square',
          advlist_number_styles: 'default',
          imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
          default_link_target: '_blank',
          link_title: false,
          init_instance_callback: editor => {
            if (_this.value) {
              editor.setContent(_this.value);
            }
            _this.hasInit = true;
            editor.on('NodeChange Change KeyUp SetContent', () => {
              this.hasChange = true;
              this.$emit('input', editor.getContent());
            });
            editor.on('paste', (e) => {
              var clipboardData = e.clipboardData || window.clipboardData;
              var pastedData = clipboardData.getData('Text');
              if (this.isLetiaoSystem(pastedData)) {
                this.$emit('paste', pastedData.replace('[letiao]', ''));
                event.preventDefault();
              }
            });
          },
          setup(editor) {
            editor.on('PostProcess', function (e) {
              e.content = e.content.replace(/<br \/>/g, '\n');
            });
            editor.on('FullscreenStateChanged', (e) => {
              _this.fullscreen = e.state;
            });
            editor.on('keydown', function (e) {
              if (e.keyCode === 13 && !e.ctrlKey) {
                event.preventDefault();
                _this.$emit('sendmessage');
                return false;
              }
            });
          },
        });
      },
      isLetiaoSystem(val) {
        if (val) {
          val = '' + val;
          return val.indexOf('[letiao]') == 0;
        }
        return false;
      },
      destroyTinymce() {
        if (window.tinymce.get(this.tinymceId)) {
          window.tinymce.get(this.tinymceId).destroy();
        }
      },
      setContent(value) {
        window.tinymce.get(this.tinymceId).setContent(value);
      },
      getContent() {
        window.tinymce.get(this.tinymceId).getContent();
      },
      imageSuccessCBK(imgUrl) {
        this.$emit('sendmessage', imgUrl);
      },
      fileSuccess(fileUrl, fileName) {
        this.$emit('sendmessage', fileUrl, fileName);
      },
      resumeSuccess(str) {
        this.$emit('paste', str.replace('[letiao]', ''));
      },
      hrPackageSuccess(str) {
        this.$emit('paste', str.replace('[letiao]', ''));
      },
      onPaste(str) {
        this.$emit('paste', str.replace('[letiao]', ''));
      }
    },
    destroyed() {
      this.destroyTinymce();
    }
  };
</script>

<style scoped>
  .tinymce-container {
    position: relative;
  }

  .tinymce-container>>>.mce-fullscreen {
    z-index: 10000;
  }

  .tinymce-textarea {
    visibility: hidden;
    z-index: -1;
  }

  .editor-custom-btn-container {
    position: absolute;
    left: 34px;
    top: 2px;
    /*z-index: 2005;*/
  }

  .fullscreen .editor-custom-btn-container {
    z-index: 10000;
    position: fixed;
  }

  .editor-upload-btn {
    display: inline-block;
  }
</style>